import type { Tile } from "../engine";
import { ROAD_CONNECT_E, ROAD_CONNECT_N, ROAD_CONNECT_S, ROAD_CONNECT_W } from "./roadConnectFlags";
import { roadNeighborMask } from "./roadConnectivity";

export const DROP_ZONE_OVERLAY_LAYER_NAMES = [
  "overlay-north",
  "overlay-east",
  "overlay-south",
  "overlay-west",
] as const;

export type DropZoneOverlayLayerName = (typeof DROP_ZONE_OVERLAY_LAYER_NAMES)[number];

const OVERLAY_BY_MASK: ReadonlyArray<{
  mask: number;
  layer: DropZoneOverlayLayerName;
}> = [
  { mask: ROAD_CONNECT_N, layer: "overlay-north" },
  { mask: ROAD_CONNECT_E, layer: "overlay-east" },
  { mask: ROAD_CONNECT_S, layer: "overlay-south" },
  { mask: ROAD_CONNECT_W, layer: "overlay-west" },
];

export function resolveDropZoneOverlayLayerNames({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): DropZoneOverlayLayerName[] {
  const mask = roadNeighborMask({ tiles, width, x, y });
  return OVERLAY_BY_MASK.filter(({ mask: bit }) => (mask & bit) !== 0).map(({ layer }) => layer);
}
